import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React from "react";
import servicioHttp from '../servicio/ServicioHttp';
import { Growl } from "primereact/growl";
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from "primereact/inputtext";
import servicioObjetos from '../servicio/ServicioObjetos';
import { Message } from 'primereact/message';

const MENSAJE_REQUERIDO = "Información requerida";
export class Inpc extends React.Component {


    constructor() {
        super();
        this.state = {
            paginacion: { registrosPorPagina: 30 },
            inpc: {},
            errores: {},
            mostrarDialogAgregar: false,
            mostrarDialogEditar: false,
            mostrarDialogEliminar: false,
            desarrollador: false
        };
    }

    componentDidMount() {
        this.inpc();
        this.obtnerUsuarioDesarrollador();
    }

    obtnerUsuarioDesarrollador = () => {
        servicioHttp.consumirPostHttp('usuario/obtener_usuario_sesion_perfil.json').then(response => {
            if (response.data.mensaje === "existe") {
                this.setState({ desarrollador: true });
            }
        }).catch(error => {
        });
    }

    inpc = () => {
        servicioHttp.consumirPostHttp("inpc/consulta_inpc.json").then(response => {
            this.setState({ paginacion: response.data.objeto });
        }).catch(error => {
        });
    }

    mostrarModalAgregar = () => {
        this.setState({ mostrarDialogAgregar: true });
    };

    mostrarModalEditar = () => {
        this.setState({ mostrarDialogEditar: true });
    };

    mostrarModalEliminar = (objeto) => {
        this.setState({ mostrarDialogEliminar: true, inpc: objeto });
    }

    cerrarModalAgregar = () => {
        this.setState({
            mostrarDialogAgregar: false
        });
        this.reset();
    }

    cerrarModalEditar = () => {
        this.setState({
            mostrarDialogEditar: false
        });
        this.reset();
    }

    cerrarModalEliminar = () => {
        this.setState({ mostrarDialogEliminar: false });
        this.reset();
    }

    asignaValor = (event, mayusculas) => {
        servicioObjetos.asignarAtributosObjeto(event, this, mayusculas);
    };

    reset = () => {
        this.setState({
            inpc: {},
            errores: {}
        });
    }

    asignaValor = (event, mayusculas) => {
        servicioObjetos.asignarAtributosObjeto(event, this, mayusculas);
    };

    guardarInpc = () => {
        let { inpc } = this.state;
        let guardaInpc = { ...inpc };
        let validForm = this.validarFormulario(guardaInpc);
        this.setState({ errores: validForm });
        if (!Object.keys(validForm).length) {
            guardaInpc.anio = inpc.anio;
            guardaInpc.enero = inpc.enero;
            guardaInpc.febrero = inpc.febrero;
            guardaInpc.marzo = inpc.marzo;
            guardaInpc.abril = inpc.abril;
            guardaInpc.mayo = inpc.mayo;
            guardaInpc.junio = inpc.junio;
            guardaInpc.julio = inpc.julio;
            guardaInpc.agosto = inpc.agosto;
            guardaInpc.septiembre = inpc.septiembre;
            guardaInpc.octubre = inpc.octubre;
            guardaInpc.noviembre = inpc.noviembre;
            guardaInpc.diciembre = inpc.diciembre;
            servicioHttp.consumirPostHttp("inpc/guardar_inpc.json", guardaInpc).then((response) => {
                this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
                this.componentDidMount();
                this.cerrarModalAgregar();
            }).catch(error => {
                return this.growl.show({ severity: 'error', summary: '', detail: 'Se generó un error inesperado!!!, por favor inténtelo de nuevo' });
            })
        }
    }

    editarInpc = () => {
        let { inpc } = this.state;
        let validForm = this.validarFormulario(inpc);
        this.setState({ errores: validForm });
        if (!Object.keys(validForm).length) {
            servicioHttp.consumirPostHttp("inpc/actualizar_inpc.json", inpc).then(response => {
                this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
                this.componentDidMount();
                this.cerrarModalEditar();
            }).catch(error => {
                return this.growl.show({ severity: 'error', summary: '', detail: 'Se generó un error inesperado!!!, por favor inténtelo de nuevo' });
            })
        }
    }

    eliminarInpc = () => {
        let { inpc } = this.state;
        servicioHttp.consumirPostHttp("inpc/inpc_elimina.json", inpc).then(response => {
            this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
            this.componentDidMount();
            this.cerrarModalEliminar();
        }).catch(error => {
            return this.growl.show({ severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
        })

    }

    validarFormulario = (inpc) => {
        let errores = {};

        if (servicioObjetos.esObjetoVacio(inpc.anio)) {
            errores.anio = MENSAJE_REQUERIDO;
        }
        return errores;
    }

    actualizar(objeto) {
        var inpcEditar = JSON.parse(JSON.stringify(objeto));
        this.setState({ mostrarDialogEditar: true, inpc: inpcEditar });
    }

    plantillaOpciones = (rowData, column) => {
        return <div className="p-grid">
            <div className="p-col-12 p-md-6">
                <Button type="button" icon="pi-md-edit" onClick={(e) => this.actualizar(column.rowData)}
                    className="p-button-warning" name="editar" tooltip="Editar información">
                </Button>
            </div>
            <div className="p-col-12 p-md-6">
                <Button type="button" icon="pi-md-delete" onClick={(e) => this.mostrarModalEliminar(column.rowData)}
                    className="p-button-danger" name="eliminar" tooltip="Eliminar registro" >
                </Button>
            </div>
        </div>;
    }

    render() {
        let { paginacion, inpc, errores, mostrarDialogAgregar, mostrarDialogEditar, mostrarDialogEliminar, desarrollador } = this.state;
        let pieTablaBotones = <div className="p-fluid p-grid">
            <div className="p-col-12 p-md-3">
                {desarrollador ?
                    <Button className="p-button-secondary" type="button" name="agregarEjercicio" label="Agregar Ejercicio" tooltip="Agregar Ejercicio" icon="pi-md-plus" onClick={this.mostrarModalAgregar}></Button>
                    : null}
            </div>
        </div>;
        const pieDialogoExaminar = (
            <div>
                <Button icon="pi-md-save" onClick={this.guardarInpc} label="Guardar" />
                <Button icon="pi-md-close" onClick={this.cerrarModalAgregar} label="Cancelar" className="p-button-danger flat-btn" />
            </div>
        );

        const pieDialogo = (
            <div>
                <Button icon="pi-md-check" onClick={this.editarInpc} label="Aceptar" />
                <Button icon="pi-md-close" onClick={this.cerrarModalEditar} label="Cancelar" className="p-button-danger flat-btn" />
            </div>
        );

        const pieDialogEliminar = (
            <div>
                <Button icon="pi-md-check" onClick={this.eliminarInpc} label="Si estoy seguro" />
                <Button icon="pi-md-close" onClick={this.cerrarModalEliminar} label="No estoy seguro" className="p-button-danger flat-btn" />
            </div>
        );

        return (
            <div className="p-fluid">
                <Growl ref={(el) => this.growl = el} />
                <div className="card card-w-whiteg">
                    <div className="p-grid">
                        <div className="col-12 p-md-12">
                            <h1>ÍNDICE NACIONAL DE PRECIOS AL CONSUMIDOR</h1>
                        </div>

                        <div className="p-col-12 p-md-12">
                            <label></label>
                        </div>

                        <div className="p-col-12 p-md-12">
                            <DataTable footer={pieTablaBotones} value={paginacion.datos} header="INPC" resizableColumns={true} responsive={true} paginator={true} rows={10}>
                                <Column header="AÑO" field="anio" style={{ width: '150px' }} autoLayout={true} />
                                <Column header="ENERO" field="enero" style={{ width: '150px' }} autoLayout={true} />
                                <Column header="FEBRERO" field="febrero" style={{ width: '150px' }} autoLayout={true} />
                                <Column header="MARZO" field="marzo" style={{ width: '150px' }} autoLayout={true} />
                                <Column header="ABRIL" field="abril" style={{ width: '150px' }} autoLayout={true} />
                                <Column header="MAYO" field="mayo" style={{ width: '150px' }} autoLayout={true} />
                                <Column header="JUNIO" field="junio" style={{ width: '150px' }} autoLayout={true} />
                                <Column header="JULIO" field="julio" style={{ width: '150px' }} autoLayout={true} />
                                <Column header="AGOSTO" field="agosto" style={{ width: '150px' }} autoLayout={true} />
                                <Column header="SEPTIEMBRE" field="septiembre" style={{ width: '150px' }} autoLayout={true} />
                                <Column header="OCTUBRE" field="octubre" style={{ width: '150px' }} autoLayout={true} />
                                <Column header="NOVIEMBRE" field="noviembre" style={{ width: '150px' }} autoLayout={true} />
                                <Column header="DICIEMBRE" field="diciembre" style={{ width: '150px' }} autoLayout={true} />
                                {desarrollador === true ?
                                    <Column header="OPCIONES" body={this.plantillaOpciones} style={{ width: '80px' }} autoLayout={true} />
                                    : null}
                            </DataTable>
                        </div>

                        <Dialog style={{ width: '40%', height: '60%' }} appendTo={document.body} header="Agregar registro - INPC" visible={mostrarDialogAgregar}
                            modal={true} onHide={this.cerrarModalAgregar} footer={pieDialogoExaminar}>
                            <div className="p-grid">
                                <div className="p-col-12 p-md-12">
                                    <label></label>
                                </div>

                                <div className="p-col-12 p-md-3">
                                    <label></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <label><strong>*Año:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="inpc.anio" name="inpc.anio" value={inpc.anio || ""}
                                        className={errores.anio ? "p-error" : ""} placeholder="YYYY" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="4" style={{ width: "100%" }} keyfilter="pint" />
                                    {errores.anio ? <Message severity="error" text={errores.anio} /> : null}
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <label></label>
                                </div>

                                <div className="p-col-12 p-md-12">
                                    <label></label>
                                </div>

                                <div className="p-col-12 p-md-3">
                                    <label><strong>Enero:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="inpc.enero" name="inpc.enero" value={inpc.enero || ""}
                                        className={errores.enero ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <label><strong>Febrero:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="inpc.febrero" name="inpc.febrero" value={inpc.febrero || ""}
                                        className={errores.febrero ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>

                                <div className="p-col-12 p-md-3">
                                    <label><strong>Marzo:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="inpc.marzo" name="inpc.marzo" value={inpc.marzo || ""}
                                        className={errores.marzo ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <label><strong>Abril:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="inpc.abril" name="inpc.abril" value={inpc.abril || ""}
                                        className={errores.abril ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>

                                <div className="p-col-12 p-md-3">
                                    <label><strong>Mayo:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="inpc.mayo" name="inpc.mayo" value={inpc.mayo || ""}
                                        className={errores.mayo ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <label><strong>Junio:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="inpc.junio" name="inpc.junio" value={inpc.junio || ""}
                                        className={errores.junio ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>

                                <div className="p-col-12 p-md-3">
                                    <label><strong>Julio:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="inpc.julio" name="inpc.julio" value={inpc.julio || ""}
                                        className={errores.julio ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <label><strong>Agosto:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="inpc.agosto" name="inpc.agosto" value={inpc.agosto || ""}
                                        className={errores.agosto ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>

                                <div className="p-col-12 p-md-3">
                                    <label><strong>Septiembre:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="inpc.septiembre" name="inpc.septiembre" value={inpc.septiembre || ""}
                                        className={errores.septiembre ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <label><strong>Octubre:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="inpc.octubre" name="inpc.octubre" value={inpc.octubre || ""}
                                        className={errores.octubre ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>

                                <div className="p-col-12 p-md-3">
                                    <label><strong>Noviembre:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="inpc.noviembre" name="inpc.noviembre" value={inpc.noviembre || ""}
                                        className={errores.noviembre ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <label><strong>Diciembre:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="inpc.diciembre" name="inpc.diciembre" value={inpc.diciembre || ""}
                                        className={errores.diciembre ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>
                            </div>
                        </Dialog>
                        <Dialog style={{ width: '40%', height: '60%' }} appendTo={document.body} header="Editar registro - INPC" visible={mostrarDialogEditar}
                            modal={true} onHide={this.cerrarModalEditar} footer={pieDialogo}>
                            <div className="p-grid">
                                <div className="p-col-12 p-md-12">
                                    <label></label>
                                </div>

                                <div className="p-col-12 p-md-3">
                                    <label></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <label><strong>*Año:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="inpc.anio" name="inpc.anio" value={inpc.anio || ""}
                                        className={errores.anio ? "p-error" : ""} placeholder="YYYY" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="4" style={{ width: "100%" }} keyfilter="pint" />
                                    {errores.anio ? <Message severity="error" text={errores.anio} /> : null}
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <label></label>
                                </div>

                                <div className="p-col-12 p-md-12">
                                    <label></label>
                                </div>

                                <div className="p-col-12 p-md-3">
                                    <label><strong>Enero:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="inpc.enero" name="inpc.enero" value={inpc.enero || ""}
                                        className={errores.enero ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <label><strong>Febrero:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="inpc.febrero" name="inpc.febrero" value={inpc.febrero || ""}
                                        className={errores.febrero ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>

                                <div className="p-col-12 p-md-3">
                                    <label><strong>Marzo:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="inpc.marzo" name="inpc.marzo" value={inpc.marzo || ""}
                                        className={errores.marzo ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <label><strong>Abril:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="inpc.abril" name="inpc.abril" value={inpc.abril || ""}
                                        className={errores.abril ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>

                                <div className="p-col-12 p-md-3">
                                    <label><strong>Mayo:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="inpc.mayo" name="inpc.mayo" value={inpc.mayo || ""}
                                        className={errores.mayo ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <label><strong>Junio:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="inpc.junio" name="inpc.junio" value={inpc.junio || ""}
                                        className={errores.junio ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>

                                <div className="p-col-12 p-md-3">
                                    <label><strong>Julio:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="inpc.julio" name="inpc.julio" value={inpc.julio || ""}
                                        className={errores.julio ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <label><strong>Agosto:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="inpc.agosto" name="inpc.agosto" value={inpc.agosto || ""}
                                        className={errores.agosto ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>

                                <div className="p-col-12 p-md-3">
                                    <label><strong>Septiembre:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="inpc.septiembre" name="inpc.septiembre" value={inpc.septiembre || ""}
                                        className={errores.septiembre ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <label><strong>Octubre:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="inpc.octubre" name="inpc.octubre" value={inpc.octubre || ""}
                                        className={errores.octubre ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>

                                <div className="p-col-12 p-md-3">
                                    <label><strong>Noviembre:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="inpc.noviembre" name="inpc.noviembre" value={inpc.noviembre || ""}
                                        className={errores.noviembre ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <label><strong>Diciembre:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="inpc.diciembre" name="inpc.diciembre" value={inpc.diciembre || ""}
                                        className={errores.diciembre ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, false)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                </div>
                            </div>
                        </Dialog>
                        <Dialog style={{ width: '50%', height: '30%' }} header="Eliminar registro - INPC" visible={mostrarDialogEliminar} modal={true}
                            footer={pieDialogEliminar} onHide={this.cerrarModalEliminar}>
                            <div className="p-grid">
                                <div className="p-col-12 p-md-12">
                                    <center><h2><strong>¿Estás seguro de eliminar este registro?</strong></h2></center>
                                </div>
                            </div>
                        </Dialog>
                    </div>
                </div>
            </div>
        );
    }
}